module.exports = __webpack_public_path__ + "img/marp-loading.688fe3dd.svg";